import { defineMessages } from "react-intl";

const ReportsMessages = defineMessages({
  reports: {
    defaultMessage: "Reports",
    id: "reports.myReports.header",
  },
  myReports: {
    defaultMessage: "My Reports",
    id: "reports.myReports",
  },
  reportName: {
    defaultMessage: "Report",
    id: "reports.myReports.reportName",
  },
  reportStatus: {
    defaultMessage: "Status",
    id: "reports.myReports.reportStatus",
  },
  reportType: {
    defaultMessage: "Type",
    id: "reports.myReports.reportType",
  },
  dateRange: {
    defaultMessage: "Date Range",
    id: "reports.myReports.dateRange",
  },
  lastUpdate: {
    defaultMessage: "Last Update",
    id: "reports.myReports.lastUpdate",
  },
  edit: {
    defaultMessage: "Edit",
    id: "reports.myReports.edit",
  },
  activate: {
    defaultMessage: "Activate",
    id: "reports.myReports.activate",
  },
  deactivate: {
    defaultMessage: "Deactivate",
    id: "reports.myReports.deactivate",
  },
  exportReport: {
    defaultMessage: "Export",
    id: "reports.myReports.exportReport",
  },
  numSelected: {
    defaultMessage: "{numSelected} Selected",
    id: "reports.myReports.list.numSelected",
    parameterized: true,
  },
  toastSuccess: {
    defaultMessage: "Success",
    id: "reports.myReports.toast.success",
  },
  updateReportSuccessMessage: {
    defaultMessage: "The report status has been updated successfully.",
    id: "reports.myReports.updateReportSuccessMessage",
  },
  active: {
    defaultMessage: "Active",
    id: "reports.myReports.active",
  },
  inactive: {
    defaultMessage: "Inactive",
    id: "reports.myReports.inactive",
  },
  all: {
    defaultMessage: "All",
    id: "reports.myReports.all",
  },
  addDataReport: {
    defaultMessage: "Add Report",
    id: "reports.myReports.addDataReport",
  },
  all_dimensions_and_metrics: {
    defaultMessage: "All Dimensions and Metrics",
    id: "reports.myReports.reportType.allDimensionsAndMetrics",
  },
  all_dimensions_and_metrics_ecosystem_cost: {
    defaultMessage: "All Dimensions and Metrics Ecosystem Cost",
    id: "reports.myReports.reportType.allDimensionsAndMetricsEcosystemCost",
  },
  app_transparency: {
    defaultMessage: "App Transparency",
    id: "reports.myReports.reportType.appTransparency",
  },
  audience_index: {
    defaultMessage: "Audience Index",
    id: "reports.myReports.reportType.audienceIndex",
  },
  audience_index_pixel: {
    defaultMessage: "Audience Index Pixel",
    id: "reports.myReports.reportType.audienceIndexPixel",
  },
  brain_feature_summary: {
    defaultMessage: "Brain Feature Summary",
    id: "reports.myReports.reportType.brainFeatureSummary",
  },
  brain_feature_value: {
    defaultMessage: "Brain Feature Value",
    id: "reports.myReports.reportType.brainFeatureValue",
  },
  by_hour: {
    defaultMessage: "By Hour",
    id: "reports.myReports.reportType.byHour",
  },
  contextual_insights: {
    defaultMessage: "Contextual Insights",
    id: "reports.myReports.reportType.contextualInsights",
  },
  data_pixel_loads: {
    defaultMessage: "Data Pixel Loads",
    id: "reports.myReports.reportType.dataPixelLoads",
  },
  day_part: {
    defaultMessage: "Day Part",
    id: "reports.myReports.reportType.dayPart",
  },
  device_technology: {
    defaultMessage: "Device Technology",
    id: "reports.myReports.reportType.deviceTechnology",
  },
  event_pixel_loads: {
    defaultMessage: "Event Pixel Loads",
    id: "reports.myReports.reportType.eventPixelLoads",
  },
  geo: {
    defaultMessage: "Geo",
    id: "reports.myReports.reportType.geo",
  },
  hyperlocal: {
    defaultMessage: "Hyperlocal",
    id: "reports.myReports.reportType.hyperlocal",
  },
  performance: {
    defaultMessage: "Performance",
    id: "reports.myReports.reportType.performance",
  },
  postal_code: {
    defaultMessage: "Postal Code",
    id: "reports.myReports.reportType.postalCode",
  },
  reach_frequency: {
    defaultMessage: "Reach & Frequency",
    id: "reports.myReports.reportType.reachFrequency",
  },
  site_transparency: {
    defaultMessage: "Site Transparency",
    id: "reports.myReports.reportType.siteTransparency",
  },
  site_transparency_viewability: {
    defaultMessage: "Site Transparency Viewability",
    id: "reports.myReports.reportType.siteTransparencyViewability",
  },
  watermark: {
    defaultMessage: "Watermark",
    id: "reports.myReports.reportType.watermark",
  },
  win_loss: {
    defaultMessage: "Win/Loss",
    id: "reports.myReports.reportType.winLoss",
  },
  win_loss_creative: {
    defaultMessage: "Win/Loss Creative",
    id: "reports.myReports.reportType.winLossCreative",
  },

  last_7_hours_inclusive: {
    defaultMessage: "Last 7 Hours",
    id: "reports.myReports.reportTimeWindow.last7HoursInclusive",
  },
  yesterday: {
    defaultMessage: "Yesterday",
    id: "reports.myReports.reportTimeWindow.yesterday",
  },
  last_1_days: {
    defaultMessage: "Last 1 Day",
    id: "reports.myReports.reportTimeWindow.last1Day",
  },
  last_x_days: {
    defaultMessage: "Last X Days",
    id: "reports.myReports.reportTimeWindow.lastXDays",
  },
  last_7_days: {
    defaultMessage: "Last 7 Days",
    id: "reports.myReports.reportTimeWindow.last7Days",
  },
  last_14_days: {
    defaultMessage: "Last 14 Days",
    id: "reports.myReports.reportTimeWindow.last14Days",
  },
  last_30_days: {
    defaultMessage: "Last 30 Days",
    id: "reports.myReports.reportTimeWindow.last30Days",
  },
  last_45_days: {
    defaultMessage: "Last 45 Days",
    id: "reports.myReports.reportTimeWindow.last45Days",
  },
  month_to_date: {
    defaultMessage: "Month to Date",
    id: "reports.myReports.reportTimeWindow.monthToDate",
  },
  campaign_to_date: {
    defaultMessage: "Campaign to Date",
    id: "reports.myReports.reportTimeWindow.campaignToDate",
  },
  cancel: {
    defaultMessage: "Cancel",
    id: "reports.myReports.cancel",
  },
  save: {
    defaultMessage: "Save",
    id: "reports.myReports.save",
  },
  downloadCooldownError: {
    defaultMessage:
      "Export cooldown active. Please wait {remainingTime} seconds.",
    id: "reports.myReports.downloadCooldownError",
    parameterized: true,
  },
  downloadError: {
    defaultMessage: "Error",
    id: "reports.myReports.downloadError",
  },
  downloadSuccess: {
    defaultMessage: "Report exported successfully.",
    id: "reports.myReports.downloadSuccess",
  },
  noReportsSelected: {
    defaultMessage: "No reports selected for export.",
    id: "reports.myReports.noReportsSelected",
  },
  bulkDownloadSuccess: {
    defaultMessage: "{count} report(s) exported successfully.",
    id: "reports.myReports.bulkDownloadSuccess",
    parameterized: true,
  },
  bulkDownloadFailed: {
    defaultMessage: "{count} report(s) failed to export.",
    id: "reports.myReports.bulkDownloadFailed",
    parameterized: true,
  },
  bulkDownloadCooldown: {
    defaultMessage: "{count} report(s) on cooldown.",
    id: "reports.myReports.bulkDownloadCooldown",
    parameterized: true,
  },
});

export default ReportsMessages;
